import * as React from 'react';
export const IcHdrAuto = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12 13h-2a1 1 0 00-1 1v6a1 1 0 001 1h2c1 0 3-.84 3-4s-2-4-3-4zm0 6h-1v-4h1c.17 0 1 .16 1 2s-.83 2-1 2zm-5-6a1 1 0 00-1 1v2H4v-2a1 1 0 10-2 0v6a1 1 0 102 0v-2h2v2a1 1 0 102 0v-6a1 1 0 00-1-1zm12 0h-2a1 1 0 00-1 1v6a1 1 0 002 0v-1h1c.12.01.24.01.36 0l.75 1.49A1 1 0 0021 21a.93.93 0 00.45-.11 1 1 0 00.44-1.34l-.73-1.47A3 3 0 0019 13zm0 4h-1v-2h1a1 1 0 010 2zm1-14h-4a2 2 0 00-2 2v4a2 2 0 002 2h4a2 2 0 002-2V5a2 2 0 00-2-2zm-.32 6.47h-.18a.51.51 0 01-.5-.29l-.25-.68h-1.53l-.22.68a.51.51 0 01-.65.29.52.52 0 01-.35-.65l1.5-4a.52.52 0 01.94 0l1.5 4a.51.51 0 01-.26.65zm-2.08-2h.8L18 6.42l-.4 1.05z'
      fill='currentColor'
    />
  </svg>
);
